import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class GaiaApi extends Requestor {
    getConstantGroup(params = {}) {
        return this.get({
            url: '/api/v1/gaia/constant-group',
            params,
        });
    }
}
export default new GaiaApi(clientInstance);
